import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appScrollAnimate]',
  standalone: true,
})
export class ScrollAnimateDirective implements OnInit, OnDestroy {
  /** The animation class(es) to add when the element enters the viewport.
   *  e.g. appScrollAnimate="animate-fade-in-up"
   *  or   appScrollAnimate="animate-move-in-right"
   */
  @Input('appScrollAnimate') animationClass: string = '';

  /** Optional delay override in ms, e.g. [scrollDelay]="200" */
  @Input() scrollDelay: number = 0;

  /** How much of the element must be visible before triggering (0–1) */
  @Input() scrollThreshold: number = 0.2;

  private observer!: IntersectionObserver;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    const classes = this.animationClass.trim().split(/\s+/).filter(Boolean);
    if (!classes.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const apply = () => this.el.nativeElement.classList.add(...classes);
          this.scrollDelay > 0 ? setTimeout(apply, this.scrollDelay) : apply();

          this.observer.unobserve(entry.target);
        });
      },
      { threshold: this.scrollThreshold },
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
